export const dealStagesData = {
    "Site Visit": "naH0Hq5WlwVjlu66SyoF",
    "After Site Visit Follow Up": "hdt7EgiEiZeLXJkAbJQw",
    "Sitting": "gPgKIfVobOoO8plDjaL1",
    "After Sitting Follow Up": "tzT2qiCM1ZJoppfd6l2A",
    "Plot Booked": "Q9JZE1p3V8dahjH8eMwl",
    "Advance Amount Update": "XkjJnPForSV0VRK81Pyq",
    "Registration InProgress": "lu8FY04HlUM7wtuLG3wd",
    "Fully Registered": "OeC8MZqNykSosVgiPIGx",
    "Deal Lost Before Booking": "eg6Sa6oxnxCr6ZBz4myj",
    "Deal Lost After Booking": "f8ddj5YskQd26cPDcqZM",
  };